import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import Dropdown from "./Education/Dropdown";

export default function HomeEducation({ user }) {
  const navigate = useNavigate();

  const goNext = () => {
    navigate("/InvestDef");
  };

  return (
    <div className="h-screen overflow-hidden">
      <Navbar user={user} />
      <Dropdown />
      <div className="w-full flex flex-col justify-center items-center overflow-hidden">
        <div className="text-[#000000] text-3xl mt-44">
          Welcome to the Education Homepage!
        </div>
        <div className="text-[#000000] text-3xl">
          This page was made to give you a general overview of
        </div>
        <div className="text-[#000000] text-3xl">
          the topics that our website covers.
        </div>
        <div className="text-[#000000] text-3xl"></div>
        <div className="text-[#000000] text-3xl mt-8">
          To get started, click on one of the options in the sidebar
        </div>
        <div className="text-[#000000] text-3xl  ">or press Start.</div>
        <button
          className="bg-[#73C4FC] text-[#FFFFFF] p-3 mt-10 text-2xl rounded-lg"
          onClick={goNext}
        >
          Start
        </button>
      </div>
    </div>
  );
}
